import { render, staticRenderFns } from "./19.vue?vue&type=template&id=2351ddc1&scoped=true&"
import script from "./19.vue?vue&type=script&lang=js&"
export * from "./19.vue?vue&type=script&lang=js&"
import style0 from "./19.vue?vue&type=style&index=0&id=2351ddc1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2351ddc1",
  null
  
)

export default component.exports